import { atom } from 'recoil';
import { IConfigSubArea } from '../../../commons/types/config';

export const configSubAreaAtom = atom<IConfigSubArea[]>({
  key: 'configSubArea',
  default: [] as IConfigSubArea[],
});
